import styled from 'styled-components';

import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  IconWrapper: styled.div`
    padding: ${SPACING.size12} ${SPACING.size16};
    display: flex;
    align-items: center;
  `,

  Button: styled.button`
    border: none;
    background: none;
    padding: ${SPACING.size12} ${SPACING.size16};
    cursor: pointer;
    display: flex;
    align-items: center;
  `
};
